import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link,useLocation } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userResetPassword } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
// import logo from "../../assets/images/logo.svg";
import logo from "assets/images/logo.png"

const EmailConfirmation = props => {

  //meta title
  document.title = "Forget Password | TenderSoftware - Flexi TracBoard";

  const dispatch = useDispatch();
  const { search } = useLocation();
  const parameters = new URLSearchParams(search);
  const token = parameters.get('token');

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: '',
      confirmpassword: "",
    },

    validationSchema: Yup.object({
      password: Yup.string().required("Please enter your Password").min(6),
      confirmpassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords don't match!")
        .required("Please Enter Your Verify Password"),

    }),
    onSubmit: (values) => {
      const resetparams = {
        token,
        password: values.password
      }
      dispatch(userResetPassword(resetparams, props.history));
    }
  });

  const { forgetError, forgetSuccessMsg, resetSuccessMsg, reseterrorMsg } = useSelector(state => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
    resetSuccessMsg: state.ForgetPassword.resetSuccessMsg,
    reseterrorMsg: state.ForgetPassword.resetError
  }));

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7} className="padd-right-0">
                      <div className="text-primary p-4 padd-right-0">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to FlexiTracBoard.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {reseterrorMsg && reseterrorMsg ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {reseterrorMsg.message}
                      </Alert>
                    ) : null}
                    {resetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {resetSuccessMsg.message}
                      </Alert>
                    ) : null}

                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          className="form-control"
                          placeholder="Enter Password"
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>


                      <div className="mb-3">
                        <Label className="form-label">Confirm Password</Label>
                        <Input
                          name="confirmpassword"
                          className="form-control"
                          placeholder="Enter Confirm Password"
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.confirmpassword || ""}
                          invalid={
                            validation.touched.confirmpassword && validation.errors.confirmpassword ? true : false
                          }
                        />
                        {validation.touched.confirmpassword && validation.errors.confirmpassword ? (
                          <FormFeedback type="invalid">{validation.errors.confirmpassword}</FormFeedback>
                        ) : null}
                      </div>

                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="submit">
                            Submit
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} TenderSoftware.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

EmailConfirmation.propTypes = {
  history: PropTypes.object,
};

export default withRouter(EmailConfirmation);
